import { render, staticRenderFns } from "./LayFooter.vue?vue&type=template&id=77f117fc&scoped=true&"
import script from "./LayFooter.vue?vue&type=script&lang=js&"
export * from "./LayFooter.vue?vue&type=script&lang=js&"
import style0 from "./LayFooter.vue?vue&type=style&index=0&id=77f117fc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "77f117fc",
  null
  
)

export default component.exports